import React from 'react';
import { Calendar, Clock, User, X, FileText, RefreshCw } from 'lucide-react';
import styles from '../CSS/ReservationDetailsModal.module.css';

const ReservationDetailsModal = ({ reservation, onClose }) => {
  if (!reservation) return null;

  const truncateText = (text, maxLength) => {
    if (!text || text.length <= maxLength) return text || '';
    return text.substring(0, maxLength) + '...';
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getDayNames = (daysArray) => {
    const dayNames = {
      1: 'Lunes',
      2: 'Martes',
      3: 'Miércoles',
      4: 'Jueves',
      5: 'Viernes'
    };
    return daysArray.map(d => dayNames[d]).join(', ');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>Detalles de la Reserva</h2>
          <button onClick={onClose} className={styles.closeButton} aria-label="Cerrar">
            <X size={20} />
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.infoSection}>
            {reservation.isPeriodic ? (
              <>
              

                <div className={styles.infoItem}>
                  <Calendar className={styles.icon} size={20} />
                  <div className={styles.infoContent}>
                    <span className={styles.label}>Periodo</span>
                    <span className={styles.value}>
                      {formatDate(reservation.startDate)} - {formatDate(reservation.endDate)}
                    </span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <Clock className={styles.icon} size={20} />
                  <div className={styles.infoContent}>
                    <span className={styles.label}>Horario</span>
                    <span className={styles.value}>
                      {reservation.startTime} - {reservation.endTime}
                    </span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <Calendar className={styles.icon} size={20} />
                  <div className={styles.infoContent}>
                    <span className={styles.label}>Días de la semana</span>
                    <span className={styles.value}>
                      {getDayNames(reservation.daysOfWeek)}
                    </span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <RefreshCw className={styles.icon} size={20} />
                  <div className={styles.infoContent}>
                    <span className={styles.label}>Total de sesiones</span>
                    <span className={styles.value}>
                      {reservation.occurrencesCount} sesiones programadas
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={styles.infoItem}>
                  <Calendar className={styles.icon} size={20} />
                  <div className={styles.infoContent}>
                    <span className={styles.label}>Fecha</span>
                    <span className={styles.value}>
                      {formatDate(reservation.date)}
                    </span>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <Clock className={styles.icon} size={20} />
                  <div className={styles.infoContent}>
                    <span className={styles.label}>Horario</span>
                    <span className={styles.value}>
                      {reservation.startTime} - {reservation.endTime}
                    </span>
                  </div>
                </div>
              </>
            )}

            <div className={styles.infoItem}>
              <FileText className={styles.icon} size={20} />
              <div className={styles.infoContent}>
                <span className={styles.label}>Título</span>
                <span className={styles.value} title={reservation.title}>
                  {reservation.title}
                </span>
              </div>
            </div>

            {reservation.description && (
              <div className={styles.infoItem}>
                <FileText className={styles.icon} size={20} />
                <div className={styles.infoContent}>
                  <span className={styles.label}>Descripción</span>
                  <span className={styles.value} title={reservation.description}>
                    {reservation.description}
                  </span>
                </div>
              </div>
            )}

            {reservation.reservedBy && (
              <div className={styles.infoItem}>
                <User className={styles.icon} size={20} />
                <div className={styles.infoContent}>
                  <span className={styles.label}>Reservado por</span>
                  <span className={styles.value}>
                    {reservation.reservedBy.displayName}
                  </span>
                </div>
              </div>
            )}
            {reservation.delegatedTo && (
  <div className={styles.infoItem}>
    <User className={styles.icon} size={20} />
    <div className={styles.infoContent}>
      <span className={styles.label}>Asignado a</span>
      <span className={styles.value}>
        {reservation.delegatedTo.displayName}
        {reservation.delegatedTo.email && ` (${reservation.delegatedTo.email})`}
        
      </span>
    </div>
  </div>
)}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button onClick={onClose} className={styles.closeBtn}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReservationDetailsModal;